import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { AuthService } from '../../../services/auth/auth.service';



@Component({
  selector: 'app-user-inner',
  imports: [],
  templateUrl: './user-inner.component.html',
  styleUrl: './user-inner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'hidden absolute z-[50] top-[3.25rem] right-0 w-72 p-4 bg-surface-0 border border-surface rounded-border origin-top shadow-[0px_3px_5px_rgba(0,0,0,0.02),0px_0px_2px_rgba(0,0,0,0.05),0px_1px_4px_rgba(0,0,0,0.08)]',
  },
})
export class UserInnerComponent {
  authService = inject(AuthService);
 

  username = computed(() => this.authService.getUsername());
  email = computed(() => this.authService.getEmail());



  logout() {
    this.authService.logout();
    document.location.reload();
  }
}
